<template>
    <div class="rebaseline-wrapper-container">
        <div class="rebaseline-card">
            <img src="@assets/img/Default.png" alt="Web Orion Logo" class="logo"/>
            <div class="title">Rebaseline via Email</div>
            <div v-if="status != 'Processing' && status != 'Completed' && !errorMessages">
                <a-alert type="info" show-icon>
                    <template slot="message">
                        Starting Baseline
                    </template>
                    <template slot="description">
                        The baseline process should start shortly...
                    </template>
                </a-alert>
            </div>
            <div v-if="(status == 'Processing' || status == 'Completed') && !errorMessages">
                <a-progress strokeLinecap="square" :percent="percentPerformingBaseline" :status="status != 'Completed' ? 'active' : null" />
                <p class="mb-0 text-center font-small baseline-message-status">
                    {{ baselineMessage }}
                </p>
            </div>
            <div v-if="status == 'Processing' && !errorMessages">
                <a-alert type="warning" show-icon>
                    <template slot="message">
                        Baseline In Progress
                    </template>
                    <template slot="description">
                        The baseline process is running. It may take a few minutes to complete.
                    </template>
                </a-alert>
            </div>
            <div v-if="status == 'Completed' && !errorMessages">
                <a-alert type="success" show-icon>
                    <template slot="message">
                        Baseline Complete
                    </template>
                    <template slot="description">
                        The baseline process is complete. Note that the link to baseline is now invalid.
                    </template>
                </a-alert>
            </div>
            <div v-if="errorMessages">
                <a-alert type="error" show-icon>
                    <template slot="message">
                        An error has occurred
                    </template>
                    <template slot="description">
                        <div v-for="msg in errorMessages" :key="msg">
                            {{ msg }}
                        </div>
                    </template>
                </a-alert>
            </div>
        </div>
        <div class="copyright">
            <p>
                WebOrion is an innovative creation of Cloudsine Pte Ltd.
                <br />
                All Rights Reserved.
            </p>
        </div>
    </div>
</template>

<script>
    import EmailRebaselineService from './services/email-rebaseline.service';

    export default {
        name: "EmailRebaseline",
        data() {
            return {
                errorMessages: null,
                rebaselineRequest: null,
                status: 'Not Started',
                baselineMessage: '',
                percentPerformingBaseline: 0,
            }
        },
        mounted() {
            let rebaselineCode = this.$route.params.code;

            EmailRebaselineService.submitRebaselineRequest(rebaselineCode).then((result) => {
                console.log(result);
                this.rebaselineRequest = result;
                this.updateJobStatus();

            }).catch((reason) => {
                this.status = "An error has occurred";
                this.errorMessages = reason.messages;
            });
        },
        methods: {
            async updateJobStatus() {
                const jobResponse = await EmailRebaselineService.fetchJobStatusFromJobUrl(this.rebaselineRequest.job_status_url);
                const { status, result } = jobResponse;
                console.log(jobResponse);

                if (status === 'Completed') {
                    setTimeout(() => {
                        this.status = status;
                        this.baselineMessage = 'Baseline completed';
                        this.percentPerformingBaseline = 100;
                    }, 2000);
                } else {
                    this.status = status;
                    this.baselineMessage = result ? JSON.parse(result).message : this.baselineMessage;
                    const percentPerforming = result ? Math.min(JSON.parse(result).start_progress, 100) : 0;
                    this.percentPerformingBaseline = +percentPerforming.toFixed();

                    setTimeout(() => {
                        this.updateJobStatus();
                    }, 3000);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .rebaseline-wrapper-container {
        width: 100%;
        min-width: 100vw;
        width: 100%;
        min-height: 100vh;
        padding: 30px;
        background-color: #f6f7fa;

        .rebaseline-card {
            width: 400px;
            background-color: #ffffff;
            border-radius: 20px;
            padding: 30px 20px;

            .logo {
                display: block;
                margin: 0 auto;
            }

            .title {
                font-size: 18px;
                margin-top: 20px;
                margin-bottom: 20px;
                text-align: center;
            }

            .baseline-message-status {
                margin-bottom: 10px;
            }
        }

        .copyright {
            width: 400px;

            p {
                margin-bottom: 0;
                margin-top: 20px;
                color: #858688;
                font-size: 11px;
                line-height: 16px;
                text-align: center;
            }
        }

        .rebaseline-card, .copyright {
            margin: 0 auto;
        }
    }
</style>
<style lang="scss">
    span.ant-alert-message {
        font-size: 16px !important;
    }
</style>
